import { app } from '@/app'

export default class Validator {

    /**
     * Init
     */
    constructor() {
        this.id = 0;
        this.error = {};
        this.types = {
            0: {
                type: 'error',
                icon: 'warning'
            },
            1: {
                type: 'success',
                icon: 'check_circle'
            },
            2: {
                type: 'warning',
                icon: 'priority_high'
            },
            3: {
                type: 'info',
                icon: 'info'
            }
        };
    }

    /**
     * Get the type data according the id type from the svr
     *
     * @ref types keys as ids to learn about the corresponding data for the key
     * @param {int} typeId
     */
    getType(typeId) {
        return this.types[typeId];
    }

    /**
     * Add msgs
     *
     * @param {string} fieldName
     * @param {object} errors
     */
    add(fieldName, errors = {}) {
        this.id += 1;
        this.error = {
            field: fieldName,
            msg: {
                ...errors,
                ...this.getType(errors.type),
                id: this.id,
            },
        };
        // clear
        this.clear();

        app.then(({ $validator }) => {
            // add
            $validator.errors.add(this.error)
        });

        return this.error;
    }

    /**
     * Clear msgs
     */
    clear() {
        app.then(({ $validator }) => {
            // add
            $validator.errors.clear();
        });
    }
}
